import React from 'react'
import styles from './index.module.scss'

import MailchimpSubscribe from "react-mailchimp-subscribe"

const URL = "//mlreview.us18.list-manage.com/subscribe/post?u=3302ee16c2f9cbb3f554c37ef&id=d6b30b77ea";

const SubscribeForm = ({ subscribe, status, message }) => {
  let input;
  const submit = () =>
    input &&
    input.value.indexOf("@") > -1 &&
    subscribe({
      EMAIL: input.value
    });

  if (status === null) {
    message = "No spam, ever. We'll never share your email address and you can opt out at any time."
  } else if (status === "sending") {
    message = "Sending..."
  }

  return (
    <form action="javascript:void(0);" onSubmit={submit}>
      <div className="input-group">
        <input
          className="input-group-field"
          ref={node => (input = node)}
          type="email"
          placeholder="Your email"
        />
        <div className="input-group-button">
          <input type="submit" className="button success" onClick={submit} value="Subscribe" />
        </div>
      </div>
      <div
        className={`${styles.message} ${styles[status]}`}
        dangerouslySetInnerHTML={{ __html: message }}
      />
    </form>
  );
}

const SubscribeBox = () => (
  <div className={styles.subscribeBox}>
    <MailchimpSubscribe url={URL} render={SubscribeForm} />
  </div>
)

export default SubscribeBox


// WEBPACK FOOTER //
// ./src/components/SubscribeBox/index.js